import React, { useRef, useState } from "react";
import Draggable from "react-draggable";

import ConfirmationModal from "../../common/components/ConfirmationModal";
import Portal from "../../common/components/Portal";

const committedOptionFromYearBreakdown = yearBreakdown =>
    yearBreakdown ? "yearBreakdown" : "recommendationElement";

const AdditionalExportOptionsModal = ({
    onCancel,
    yearBreakdown,
    onSave,
    viewOnly = false,
    isSwitchBandActive = false
}) => {
    const initialOptionRef = useRef(committedOptionFromYearBreakdown(yearBreakdown));
    const [selectedOption, setSelectedOption] = useState(() => initialOptionRef.current);
    const [showCancelConfirm, setShowCancelConfirm] = useState(false);
    const isYearBreakdownSelected = selectedOption === "yearBreakdown";

    const isDirty = !viewOnly && selectedOption !== initialOptionRef.current;

    const handleAttemptClose = () => {
        if (isDirty) {
            setShowCancelConfirm(true);
        } else {
            onCancel();
        }
    };

    return (
        <Portal
            body={
                <>
                    <div
                        className="modal modal-region smart-chart-popup smart-dtl-pop ca-additional-export-options-modal"
                        id="additionalExportOptionsModal"
                        tabIndex="-1"
                        style={{ display: "block" }}
                    >
                        <Draggable handle=".draggable" cancel=".not-draggable">
                            <div className="modal-dialog" role="document">
                                <div className="modal-content">
                                    <div className="modal-header draggable">
                                        <h5 className="modal-title">
                                            <div className="txt-hed">Additional Export Options</div>
                                        </h5>
                                        <button type="button" className="close not-draggable" onClick={handleAttemptClose}>
                                            <span aria-hidden="true">
                                                <img src="/img/close.svg" alt="" />
                                            </span>
                                        </button>
                                    </div>
                                    <div className="modal-body region-otr">
                                        <div className="ca-additional-export-options-body">
                                            <div className="ca-additional-export-options-subtitle">
                                                Choose which export option should be used for this CA Analysis configuration.
                                            </div>
                                            <div className="ca-additional-export-option-card">
                                                <label
                                                    className={`container-radio-wrap ${viewOnly ? "cursor-disabled" : ""}`}
                                                    htmlFor="additional-export-recommendation-element-radio"
                                                >
                                                    <input
                                                        type="radio"
                                                        checked={!isYearBreakdownSelected}
                                                        onChange={() => setSelectedOption("recommendationElement")}
                                                        id="additional-export-recommendation-element-radio"
                                                        name="additional-export-option"
                                                        className={`form-check-input ${viewOnly ? "cursor-disabled" : ""}`}
                                                        disabled={viewOnly}
                                                    />
                                                    <span className={`checkmark mt-1 ${viewOnly ? "cursor-disabled" : ""}`} />
                                                    <span>{isSwitchBandActive ? "Default export" : "Geo Hierarchy"}</span>
                                                </label>
                                            </div>
                                            <div className="ca-additional-export-option-card">
                                                <label
                                                    className={`container-radio-wrap ${viewOnly ? "cursor-disabled" : ""}`}
                                                    htmlFor="additional-export-capital-spending-radio"
                                                >
                                                    <input
                                                        type="radio"
                                                        checked={isYearBreakdownSelected}
                                                        onChange={() => setSelectedOption("yearBreakdown")}
                                                        id="additional-export-capital-spending-radio"
                                                        name="additional-export-option"
                                                        className={`form-check-input ${viewOnly ? "cursor-disabled" : ""}`}
                                                        disabled={viewOnly}
                                                    />
                                                    <span className={`checkmark mt-1 ${viewOnly ? "cursor-disabled" : ""}`} />
                                                    <span>Capital Spending Plan by Year Grouping</span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <div className="footer-otr col-12">
                                            <div className="btn-otrr">
                                                {!viewOnly && (
                                                    <button
                                                        type="button"
                                                        className="btn-save mr-2"
                                                        onClick={() => onSave(isYearBreakdownSelected)}
                                                    >
                                                        Save
                                                    </button>
                                                )}
                                                <button type="button" className="btn-cancel" onClick={handleAttemptClose}>
                                                    Cancel
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Draggable>
                    </div>
                    {showCancelConfirm && (
                        <ConfirmationModal
                            heading="You have unsaved changes. Are you sure you want to discard them?"
                            type="cancel"
                            onNo={() => setShowCancelConfirm(false)}
                            onYes={() => {
                                setShowCancelConfirm(false);
                                onCancel();
                            }}
                            onCloseModal={() => setShowCancelConfirm(false)}
                        />
                    )}
                </>
            }
            onCancel={() => {
                if (showCancelConfirm) {
                    setShowCancelConfirm(false);
                } else {
                    handleAttemptClose();
                }
            }}
        />
    );
};

export default AdditionalExportOptionsModal;
